
'use strict'; // jshint ignore:line
/* global URLSearchParams:false */

import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
// import request_apirid from '@/lib/request-apirid';
// import cookie from './store-cookie';
import util from '@/util';
// const COOKIE_NAME = 'alphanumeric';
// const o_cookie_initial = cookie.get( COOKIE_NAME, {} );

Vue.use(Vuex);

const store = new Vuex.Store({
   state: {
      // cookie: o_cookie_initial,
      address: '800 Glade Road, Suite 39, Colleyville, TX 76034',
      page_title: null,
      phone_main: '8177933157',
      url_location: 'https://www.google.com/maps?f=q&source=s_q&hl=en&geocode&q=1304+Glade+Rd,+76034&sll=37.0625,-95.677068&sspn=42.174768,93.076172&ie=UTF8&hq&hnear=1304+Glade+Rd,+Colleyville,+Tarrant,+Texas+76034&z=16',
      window_width: 0,
      window_height: 0,
      window_largest: 0,
      window_smallest: 0,
   },

   mutations: {
      SET_PAGE_TITLE ( state, c_title ){
         state.page_title = c_title;
      },// /SET_PAGE_TITLE()

      SET_RESOURCE_LIST ( state, a_resources ) {
         state.resources = a_resources;
      },// /SET_RESOURCE_LIST()
   },// /mutations{}

   actions: {
      set_page_title ( context, c_title ){
         context.commit( 'SET_PAGE_TITLE', c_title );
      },// /set_page_title()

      fetch_a_resource( context ){
         const c_search = new URLSearchParams({
            // apirid: request_apirid(),
         } ).toString();
         const c_name = 'fetch_resource';
         const c_url = `/${context.state.client_id}/${c_name}.wr?${c_search}`;

         return new Promise(function( resolve, reject ){
            if( context.state.resources !== null ){
               return resolve();
            }
            // const o_data = util.object_pick( o_resource, [
            //    'name',
            //    'description'
            // ] );

            axios({
               method: 'get',
               url: c_url, 
            })
            .then(( o_response ) => {
               const o_result = o_response.data;
               var o_result_error;

               // The server received our request and provided us with a valid JSON
               // response. Now we check if the web1 server's response contains an error 
               // message.
               if (o_result.error) {
                  // The server sent us an error message. Display the message to the user.
                  o_result_error = {
                     code: 500,
                     message: c_name.concat( ' Error: ', o_result.error.message ),
                     source: Object.assign( {}, o_result.error ),
                  };
                  return reject( o_result_error );
               }

               // At this point the server has provided us with the data we asked for.
               context.commit( 'SET_RESOURCE_LIST', o_result.data );
               return resolve( o_result );
            })
            .catch(( o_error ) => {
               // This can happend when web1 randomly returns a "no output" html error.
               const o_result_error = {
                  code: 500,
                  message: c_name.concat(' Failed: ', o_error.message ),
                  source: Object.assign( {}, o_error ),
               };
               return reject( o_result_error );
            });
         });
      },// /fetch_a_resource()

      create_a_resource( context, o_resource ){
         const c_name = 'create_resource';
         const c_url = `/${context.state.client_id}/${c_name}.wr?apirid=${Math.round( Math.random() * 10000 )}`;

         return new Promise(function( resolve, reject ){
            const o_data = util.object_pick( o_resource, [
               'name',
               'description'
            ] );

            axios({
               method: 'post',
               url: c_url,
               data: Object.assign( {
                  // apirid: request_apirid(),
               }, o_data ),
            })
            .then(( o_response ) => {
               const o_result = o_response.data;
               var o_result_error;

               // The server received our request and provided us with a valid JSON
               // response. Now we check if the web1 server's response contains an error 
               // message.
               if (o_result.error) {
                  // The server sent us an error message. Display the message to the user.
                  o_result_error = {
                     code: 500,
                     message: c_name.concat( ' Error: ', o_result.error.message ),
                     source: Object.assign( {}, o_result.error ),
                  };
                  return reject( o_result_error );
               }

               // At this point the server has provided us with the data we asked for.
               context.commit( 'SET_RESOURCE_LIST', o_result.data );
               return resolve( o_result );
            })
            .catch(( o_error ) => {
               // This can happend when web1 randomly returns a "no output" html error.
               const o_result_error = {
                  code: 500,
                  message: c_name.concat(' Failed: ', o_error.message ),
                  source: Object.assign( {}, o_error ),
               };
               return reject( o_result_error );
            });
         });
      },// /create_a_resource()
   },// /actions{}

   getters: {
      address( state ){
         return state.address;
      },// /address()

      page_title( state ){
         return state.page_title;
      },// /page_title()

      phone_main( state ){
         return state.phone_main;
      },// /phone_main()

      url_location( state ){
         return state.url_location;
      },// /url_location()

      window_height( state ){
         return state.window_height;
      },// /window_height()

      window_largest( state ){
         return state.window_largest;
      },// /window_largest()

      window_smallest( state ){
         return state.window_smallest;
      },// /window_smallest()

      window_width( state ){
         return state.window_width;
      },// /window_width()
   },// /getters()

   // plugins: [
   //    function( store ){
   //       store.subscribe((mut, state) => {
   //          console.log( 'mut', mut );
   //          console.log( 'state', state );
   //       });
   //    }
   // ]
});

export default store;
